import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as InformationIconImage } from './information-icon.svg';
import SvgIconWrapper from '../../../components/icons/SvgIconWrapper';

const InformationIcon = ({ svgWrapperClassName, sx }) => (
  <SvgIconWrapper
    Icon={InformationIconImage}
    svgWrapperClassName={svgWrapperClassName}
    sx={sx}
  />
);

InformationIcon.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  svgWrapperClassName: PropTypes.string,
};

InformationIcon.defaultProps = {
  sx: undefined,
  svgWrapperClassName: undefined,
};

export default InformationIcon;
